import "../styles/SocialsBar.css";
import facbookLogo from "../images/logos/facebook.png";
import instagramLogo from "../images/logos/instagram.jpeg";
import youTubeLogo from "../images/logos/youtube.png";
import linkedinLogo from "../images/logos/linkedin.png"
import gitHubLogo from "../images/logos/gitHub.jpg"
import emailLogo from "../images/logos/email.png"

function SocialsBar() {
    return(
        <div id="socialMediaBar">
        <a href="https://www.facebook.com/boughtonshields.creations" target="_blank" rel="noopener noreferrer">
            <img src={facbookLogo} alt="Facebook Logo"/>
        </a>
        <a href="https://www.instagram.com/boughtonshields.creations/" target="_blank" rel="noopener noreferrer">
            <img src={instagramLogo} alt="Instagram Logo"/>
        </a>
        <a href="https://www.youtube.com/@boughton-sheilds.creations" target="_blank" rel="noopener noreferrer">
            <img src={youTubeLogo} alt="YouTube Logo"/>
        </a>
        <a href="https://www.linkedin.com/company/boughton-shields-creations/" target="_blank" rel="noopener noreferrer">
            <img src={linkedinLogo} alt="LinkedIn Logo"/>
        </a>
        <a href="https://github.com/RyanB-Shields" target="_blank" rel="noopener noreferrer">
            <img src={gitHubLogo} alt="GitHub Logo"/>
        </a>
        <a href="mailto:ryan.boughtonshields@gmail.com?subject=Boughton-Shields Creations" target="_blank" rel="noopener noreferrer">
            <img src={emailLogo} alt="Email Logo"/>
        </a>
      </div>
    )
}

export default SocialsBar;